import { forwardRef, useCallback } from "react";
import { Link, LinkProps, useNavigate } from "react-router-dom";
import { useNavigationGuardSafe } from "@/hooks/useNavigationGuard";

/**
 * Drop-in replacement for react-router's <Link> that respects
 * the NavigationGuard context (shows unsaved-changes dialog).
 */
const GuardedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, onClick, ...props }, ref) => {
    const guardCtx = useNavigationGuardSafe();
    const navigate = useNavigate();

    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (guardCtx?.shouldBlock()) {
          e.preventDefault();
          const target = typeof to === "string" ? to : (to as any).pathname || "/";
          guardCtx.blockedHandlerRef.current?.(target);
          return;
        }
        onClick?.(e);
      },
      [guardCtx, to, onClick],
    );

    return <Link ref={ref} to={to} onClick={handleClick} {...props} />;
  },
);

GuardedLink.displayName = "GuardedLink";

export { GuardedLink };
